<div class="tables-container">
  @if (tables.length != 0) { @for (table of tables; track table) {
  <button
    (click)="tableSelected(table)"
    [class.selected]="isSelected(table)"
    [class.unselected]="!isSelected(table)"
    class="table-card"
  >
    <div (onClick)="tableSelected(table)">
      <div class="table-row">
        <div class="table-label">{{ "table_card.table_name" | translate }}</div>
        <div class="table-value">{{ table.table_name }}</div>
      </div>
      <div class="table-row">
        <div class="table-label">
          {{ "table_card.table_capacity" | translate }}
        </div>
        <div class="table-value">
          max {{ table.capacity }} / min {{ table.min_limit }}
        </div>
      </div>
      <div class="table-row">
        <div class="table-label">
          {{ "table_card.myitalian" | translate }}
        </div>
        <div class="table-value">
          @if(table.myitalian == 0){
          <i class="pi pi-times"></i>
          } @else {
          <i class="pi pi-check"></i>
          }
        </div>
      </div>
      <div class="table-row">
        <div class="table-label">{{ "table_card.datetime" | translate }}</div>
        <div class="table-value">{{ table.time }}</div>
      </div>
    </div>
  </button>
  } } @else {
  <div class="message">
    <div class="icon">
      <img src="../../../../assets/images/Info.svg" alt="Info icon" />
    </div>
    <div
      class="text"
      [innerHTML]="'third_party_reservation.no_spots_available' | translate"
    ></div>
  </div>
  }
</div>
